var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientOfferModellerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.49681 13.5251L0 8.79688V15.4991H15V8.9174L7.49681 13.5251Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.9043 0.5V8.84639L7.50381 12.3778L13.0957 8.94365V0.5L1.9043 0.5ZM7.4915 5.86133C8.48525 5.86133 9.29326 6.59434 9.29326 7.49521C9.29326 8.25869 8.71289 8.90117 7.93096 9.07959V9.75781H7.05205V9.07959C6.27041 8.90117 5.68975 8.25869 5.68975 7.49521H6.56865C6.56865 7.91123 6.98291 8.2499 7.4915 8.2499C8.00039 8.2499 8.41436 7.91123 8.41436 7.49521C8.41436 7.07891 8.00039 6.74023 7.4915 6.74023C6.49805 6.74023 5.68975 6.00723 5.68975 5.10635C5.68975 4.34287 6.27041 3.70039 7.05205 3.52197V2.84375H7.93096V3.52197C8.71289 3.70039 9.29326 4.34287 9.29326 5.10635H8.41436C8.41436 4.69033 8.00039 4.35166 7.4915 4.35166C6.98291 4.35166 6.56865 4.69033 6.56865 5.10635C6.56865 5.52266 6.98291 5.86133 7.4915 5.86133Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02539 5.70508L0 6.49383V7.64446L1.02539 8.29119V5.70508Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9746 5.70508V8.40325L15 7.77357V6.49384L13.9746 5.70508Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientOfferModellerIcon);
export default __webpack_public_path__ + "static/media/client-offer-modeller-icon.bf0e3999.svg";
export { ForwardRef as ReactComponent };